export var ExprError;
(function (ExprError) {
    let Type;
    (function (Type) {
        Type["InvalidAccess"] = "INVALID_ACCESS";
        Type["InvalidArgument"] = "INVALID_ARGUMENT";
        Type["InvalidArguments"] = "INVALID_ARGUMENTS";
    })(Type = ExprError.Type || (ExprError.Type = {}));
    class InvalidAccess extends Error {
        constructor(path, pathError, location) {
            super(pathError);
            this.path = path;
            this.pathError = pathError;
            this.location = location;
            this.type = "INVALID_ACCESS";
            this.name = 'InvalidAccess';
            Object.setPrototypeOf(this, InvalidAccess.prototype);
        }
    }
    ExprError.InvalidAccess = InvalidAccess;
    class InvalidArguments extends Error {
        constructor(callName, argError, location) {
            super(`${argError}`);
            this.callName = callName;
            this.argError = argError;
            this.location = location;
            this.type = "INVALID_ARGUMENT";
            this.name = 'InvalidArguments';
            Object.setPrototypeOf(this, InvalidArguments.prototype);
        }
    }
    ExprError.InvalidArguments = InvalidArguments;
    class InvalidArgument extends Error {
        constructor(callName, argName, argError, location) {
            super(`${argName ? `${argName} ${argError}` : `${argError}`}`);
            this.callName = callName;
            this.argName = argName;
            this.argError = argError;
            this.location = location;
            this.type = "INVALID_ARGUMENT";
            this.name = 'InvalidArgument';
            Object.setPrototypeOf(this, InvalidArgument.prototype);
        }
    }
    ExprError.InvalidArgument = InvalidArgument;
})(ExprError || (ExprError = {}));
